<template>
<div>
    <!-- nav -->
    <header-bar></header-bar>
    <!-- body -->
    <div class="container-fluid full-content page">
		<div class="address" style="display: flex;justify-content: center;align-items: center;"><img src="../../static/gh_5c389ff6269c_258.jpg" /></div>
        <div class="address" v-if="false">
            <p style="text-align:center;">
	    <span style="font-size:16px;color:#000000;"><strong>四川同创新锐信息技术有限公司</strong></span> 
        </p>
        <p style="text-align:justify;">
            <span style="font-size:14px;color:#000000;"> </span> 
        </p>
        <p>
            <span style="color:#333333;">四川同创新锐信息技术有限公司成立于</span><span style="color:#333333;">2011</span><span style="color:#333333;">年，依托博士、教授领衔的优质团队，在多年自贡灯会智慧运营服务</span><span style="color:#333333;">的经验基础上，推出了“</span><span style="color:#333333;">UU163</span><span style="color:#333333;">·云管家”的服务模式，致力于通过云服务，</span><span style="color:#333333;">为文旅项目提供智慧营销运营所需的软硬件和营销运营支撑的一站式服务，助力文旅项目取得更好</span><span style="color:#333333;">的经济效益。目前，公司业务正面向全国拓展，已在</span><span style="color:#333333;">18</span><span style="color:#333333;">省的</span><span style="color:#333333;">100</span><span style="color:#333333;">多个文旅项目中应用。</span> 
        </p>
        <p>
            <b><span style="color:#333333;">部分案例：</span></b><b></b> 
        </p>
        <p>
            <span style="color:#333333;">自贡国际恐龙灯会、西昌卫星发射基地景区、成都锦江夜游、成都国际熊猫灯会、贵阳梵高星空艺术展、山东峡山迎春灯会、自贡·哈尔滨冰雪嘉年华、都江堰西部音乐节、西昌螺髻九十九里风景区、云南芒市仙佛洞景区、唐山醉相思失恋博物馆、沐川龙门大峡谷漂流、中国遂宁国际莲花灯会、南阳中原彩灯节、太原古县城灯彩嘉年华、自贡燊海井景区、任丘彩灯大世界、射洪中华侏罗纪旅游探秘区、荣县大佛文化灯会、盘锦辽河湿地国际灯会、栾川恋爱星空艺术馆、武汉星空失恋博物馆、青岛即墨古城迎春灯会、自贡夜游釜溪、自贡海汤神泉、泸县龙桥百花洲、宜宾蜀南花海等。</span> 
        </p>
        <p>
            <b><span style="color:#333333;">公司地址：</span></b><span style="color:#333333;">四川省成都市武侯区人民南路四段</span><span style="color:#333333;">27</span><span style="color:#333333;">号商鼎国际</span><span style="color:#333333;">2F</span> 
        </p>
        <p>
            <span style="color:#333333;">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</span><span style="color:#333333;">四川省自贡市高新科技园区金川路</span><span style="color:#333333;">15</span><span style="color:#333333;">号附</span><span style="color:#333333;">20</span><span style="color:#333333;">号</span><span style="color:#333333;">4F </span> 
        </p>
        <p>
            <b><span style="color:#333333;">合作热线：</span></b><span style="color:#333333;">0813-8227163/18990022068</span>
        </p>
        <p style="text-align:left;">
            <span style="color:#333333;"><strong>公司荣誉：</strong></span> 
        </p>
        <p>
  
        </p>
        </div>
            

    </div>
    <footerBar></footerBar>
</div>
</template>

<script>
import headerBar from './header/Header'
import footerBar from './footer/Footer'
export default {
  name: 'contact',
  components: {
    headerBar,
    footerBar
  },
  data () {
    return {
        address:'',
        info:'',
        telephone:'',
        map:''
    }
  },
}
</script>
<style >
.container-fluid{
  margin-top: 70px;
}
.address{
    padding: 20px;
    width: 1000px;
    margin: 0 auto;
    margin-top:70px;
}
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue